import { useCallback, useEffect, useState } from "react";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import { RxDotFilled } from "react-icons/rx";
import { Link } from "react-router-dom";
import buyandwatch from "../../images/buyandwatch.svg";
import { truncate } from "../../lib/text";

const AUTOPLAY_MS = 7000;

const HeroCarousel = ({ banners = [] }) => {
  const [index, setIndex] = useState(0);

  const go = useCallback(
    (step) =>
      setIndex((prev) =>
        banners.length ? (prev + step + banners.length) % banners.length : 0
      ),
    [banners.length]
  );

  useEffect(() => setIndex(0), [banners.length]);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const timer = setInterval(() => go(1), AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, [banners.length, go]);

  if (banners.length === 0) return null;
  const current = banners[index];

  return (
    <div className="h-[400px] w-full text-white md:h-screen">
      <div className="h-full w-full">
        <div className="pointer-events-none absolute h-[400px] w-full select-none bg-gradient-to-l from-black md:h-screen" />

        <img
          className="hidden h-full w-full select-none object-cover sm:flex"
          src={current?.image}
          alt={current?.title}
        />
        <img
          className="h-full w-full select-none object-cover sm:hidden"
          src={current?.mobile_image}
          alt={current?.title}
        />

        <div className="absolute z-20 hidden gap-4 md:bottom-[5%] md:left-[5%] md:flex md:flex-row">
          <button type="button" aria-label="بنر بعدی" onClick={() => go(1)}>
            <FaCircleArrowRight
              size={40}
              className="cursor-pointer transition hover:text-brand"
            />
          </button>
          <button type="button" aria-label="بنر قبلی" onClick={() => go(-1)}>
            <FaCircleArrowLeft
              size={40}
              className="cursor-pointer transition hover:text-brand"
            />
          </button>
        </div>

        <div className="top-4 flex justify-center py-2 md:hidden">
          {banners.map((banner, dotIndex) => (
            <button
              key={banner.id ?? dotIndex}
              type="button"
              aria-label={`بنر ${dotIndex + 1}`}
              onClick={() => setIndex(dotIndex)}
              className={`cursor-pointer text-2xl ${
                dotIndex === index ? "text-brand" : "text-gray-400"
              }`}
            >
              <RxDotFilled />
            </button>
          ))}
        </div>

        <div className="absolute top-[10%] w-full p-4 sm:top-[20%] md:p-8">
          <h1 className="text-right text-4xl font-bold leading-[54px] md:text-5xl">
            {current?.title}
          </h1>

          {current?.description && (
            <p className="mt-6 w-full text-gray-200 md:max-w-[70%] lg:max-w-[50%] xl:max-w-[35%]">
              {truncate(current.description, 450)}
            </p>
          )}

          <div className="my-4">
            {current?.live === true ? (
              <Link to={`LivePlayer/${current?.id}`}>
                <button
                  type="button"
                  className="mt-8 rounded border-b-4 border-brand bg-brand px-4 py-2 text-lg font-bold text-white transition hover:bg-brand-dark"
                >
                  پخش زنده
                </button>
              </Link>
            ) : (
              current?.url && (
                <Link to={current.url}>
                  <button
                    type="button"
                    className="mt-8 flex flex-row rounded border-b-4 bg-white px-2 py-2 text-base font-medium leading-7 text-black transition hover:bg-brand hover:text-white"
                  >
                    <img
                      src={buyandwatch}
                      alt=""
                      aria-hidden="true"
                      className="ml-1 w-6"
                    />
                    خرید و تماشا
                  </button>
                </Link>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;
